import {Component, EventEmitter, Injector, OnInit, Output} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {Chart, registerables} from 'chart.js';
import {RouteUtil} from '../../../util/route.util';
import {now} from 'jalali-moment';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {DataResponse} from '../../../network/data.response';
import {NavigationEnd, RouterLink} from "@angular/router";
import {filter} from "rxjs";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent extends BaseComponent implements OnInit {

  hours: number = 0;
  minutes: number = 0;
  seconds: number = 0;
  persianDate?: any;
  lineChart: any;
  sellPrice?: any;
  buyPrice?: any;
  selectedPeriod: string = '30';
  selectedInterval: string = 'DAILY';
  private interval: any;
  @Output() contactClick = new EventEmitter<void>();
  isHomePage = false;

  constructor(injector: Injector) {
    super(injector);
    Chart.register(...registerables);
  }

  override ngOnInit() {
    super.ngOnInit();
    if (this.isBrowser) {
      this.startTimer();
    }
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isHomePage = event.urlAfterRedirects === '/';
      });
  }

  override loadOnline() {
    super.loadOnline();
    if (this.isBrowser) {
      this.serviceApi.searchPricing(this.selectedInterval, this.selectedPeriod).subscribe((res: DataResponse<any>) => {
        if (res == null) {
          SnackBarUtil.makeMessageWithAction(this, this.strings.problem_on_connecting_to_server, this.strings.retry, () => {
            this.loadOnline();
          });
          return;
        }

        if (res.data) {
          this.sellPrice = res.data.sellPrice;
          this.buyPrice = res.data.buyPrice;

          let chartData = res.data.prices.map((price: any) => ({
            time: this.convertTimestampToPersian(price.time),
            avg: price.avg
          }));

          this.renderChart(chartData);
        } else {
          SnackBarUtil.makeMessage(this, res.error!);
        }
      });
    }
  }

  renderChart(chartData: any) {
    const canvas = document.getElementById('lineChart') as HTMLCanvasElement;

    if (this.lineChart) {
      this.lineChart.destroy();
    }
    this.lineChart = new Chart(canvas, {
      type: 'line',
      data: {
        labels: chartData.map((data: any) => data.time),
        datasets: [{
          label: 'قیمت میانگین',
          data: chartData.map((data: any) => data.avg),
          borderWidth: 1,
          borderColor: '#F9D887',
          backgroundColor: '#F9D887',
          pointRadius: 0,
          pointBorderWidth: 0,
          pointHoverRadius: 0
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'category',
            display: true,
            ticks: {
              font: {
                family: 'IRANSansWeb',
                size: 12,
              },
            },
          },
          y: {
            beginAtZero: false,
            ticks: {
              font: {
                family: 'IRANSansWeb',
                size: 12,
              },
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              font: {
                family: 'IRANSansWeb',
                size: 12,
              },
            },
          },
        },
      }
    });
  }

  startTimer() {
    this.interval = setInterval(() => {
      const now = new Date();
      this.hours = now.getHours();
      this.minutes = now.getMinutes();
      this.seconds = now.getSeconds();
    }, 1000);
    this.persianDate = new Intl.DateTimeFormat('fa-IR', {year: 'numeric', month: 'long', day: 'numeric'}).format(now());

  }

  getStrokeDashoffset(unit: string): number {
    const totalUnits = unit === 'second' ? 60 : unit === 'minute' ? 60 : 24;
    const value = unit === 'second' ? this.seconds : unit === 'minute' ? this.minutes : this.hours;
    const circumference = 2 * Math.PI * 45;
    return circumference - (value / totalUnits) * circumference;
  }

  scroll(target: HTMLElement) {
    target.scrollIntoView()
  }

  onChangePeriod(event: any) {
    this.selectedPeriod = event.target.value;
    this.loadOnline();
  }

  onChangeInterval(event: any) {
    this.selectedInterval = event.target.value;
    this.loadOnline();
  }

  onAboutUsClicked() {
    this.router.navigate([RouteUtil.ABOUT_US]).then(() => {
      const outletContainer = document.getElementById('outlet-container');
      if (outletContainer) {
        outletContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  }

  onMagClicked() {
    window.open('https://baazar.ir/mag/', '_blank');
  }

  onHomeClicked() {
    this.router.navigate([RouteUtil.home_COMPONENT]).then(() => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    });
  }

  onTrustClicked() {
    this.router.navigate([RouteUtil.TRUST]).then(() => {
      const outletContainer = document.getElementById('outlet-container');
      if (outletContainer) {
        outletContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  }

  onContactClick(): void {
    this.contactClick.emit();
  }
}
